const langConfig = {
	"zh-cn": "中文",
	"en": "EN"
}
export default {
	defaultLeftSeat: 39, //默认剩余席位
	defaultTotalSeat: 50, //默认总席位
	defaultWalletAddress: "0xe3Ae5CCc215Eb973Bc5355a1E21b1aA6c684238D",
	defaultLang: "en",
	langConfig: langConfig
}